/* tslint:disable */
import {
  Library,
  Screen,
  Tag
} from '../index';

declare var Object: any;
export interface VideoInterface {
  "id": string;
  "OriginalFilenameOnServer": string;
  "OriginalFilename": string;
  "ProcessedFilename"?: string;
  "Description"?: string;
  "VideoFormat"?: string;
  "RunTime"?: number;
  "Width": number;
  "Height": number;
  "FileSize": number;
  "hash"?: string;
  "urlToOriginal"?: string;
  "urlToProcessed"?: string;
  "urlThumb1"?: string;
  "urlThumb2"?: string;
  "urlThumb3"?: string;
  "urlThumb4"?: string;
  "urlThumbVideo"?: string;
  "urlThumbGif"?: string;
  "Metadata"?: any;
  "Categories"?: string;
  "videoProfile"?: string;
  "processedId"?: string;
  "processing"?: boolean;
  "processingProgress"?: number;
  "processingError"?: string;
  "processingStartTime"?: Date;
  "processingEndTime"?: Date;
  "processingElapsedTime"?: number;
  "Container"?: string;
  "createdByIp": string;
  "lastUpdatedByIp": string;
  "createdAt": Date;
  "updatedAt": Date;
  "libraryId"?: string;
  library?: Library;
  screens?: Screen[];
  tags?: Tag[];
}

export class Video implements VideoInterface {
  "id": string;
  "OriginalFilenameOnServer": string;
  "OriginalFilename": string;
  "ProcessedFilename": string;
  "Description": string;
  "VideoFormat": string;
  "RunTime": number;
  "Width": number;
  "Height": number;
  "FileSize": number;
  "hash": string;
  "urlToOriginal": string;
  "urlToProcessed": string;
  "urlThumb1": string;
  "urlThumb2": string;
  "urlThumb3": string;
  "urlThumb4": string;
  "urlThumbVideo": string;
  "urlThumbGif": string;
  "Metadata": any;
  "Categories": string;
  "videoProfile": string;
  "processedId": string;
  "processing": boolean;
  "processingProgress": number;
  "processingError": string;
  "processingStartTime": Date;
  "processingEndTime": Date;
  "processingElapsedTime": number;
  "Container": string;
  "createdByIp": string;
  "lastUpdatedByIp": string;
  "createdAt": Date;
  "updatedAt": Date;
  "libraryId": string;
  library: Library;
  screens: Screen[];
  tags: Tag[];
  constructor(data?: VideoInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Video`.
   */
  public static getModelName() {
    return "Video";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Video for dynamic purposes.
  **/
  public static factory(data: VideoInterface): Video{
    return new Video(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Video',
      plural: 'Videos',
      path: 'Videos',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'string'
        },
        "OriginalFilenameOnServer": {
          name: 'OriginalFilenameOnServer',
          type: 'string'
        },
        "OriginalFilename": {
          name: 'OriginalFilename',
          type: 'string'
        },
        "ProcessedFilename": {
          name: 'ProcessedFilename',
          type: 'string'
        },
        "Description": {
          name: 'Description',
          type: 'string'
        },
        "VideoFormat": {
          name: 'VideoFormat',
          type: 'string'
        },
        "RunTime": {
          name: 'RunTime',
          type: 'number'
        },
        "Width": {
          name: 'Width',
          type: 'number'
        },
        "Height": {
          name: 'Height',
          type: 'number'
        },
        "FileSize": {
          name: 'FileSize',
          type: 'number'
        },
        "hash": {
          name: 'hash',
          type: 'string'
        },
        "urlToOriginal": {
          name: 'urlToOriginal',
          type: 'string'
        },
        "urlToProcessed": {
          name: 'urlToProcessed',
          type: 'string'
        },
        "urlThumb1": {
          name: 'urlThumb1',
          type: 'string'
        },
        "urlThumb2": {
          name: 'urlThumb2',
          type: 'string'
        },
        "urlThumb3": {
          name: 'urlThumb3',
          type: 'string'
        },
        "urlThumb4": {
          name: 'urlThumb4',
          type: 'string'
        },
        "urlThumbVideo": {
          name: 'urlThumbVideo',
          type: 'string'
        },
        "urlThumbGif": {
          name: 'urlThumbGif',
          type: 'string'
        },
        "Metadata": {
          name: 'Metadata',
          type: 'any'
        },
        "Categories": {
          name: 'Categories',
          type: 'string'
        },
        "videoProfile": {
          name: 'videoProfile',
          type: 'string'
        },
        "processedId": {
          name: 'processedId',
          type: 'string',
          default: 'null'
        },
        "processing": {
          name: 'processing',
          type: 'boolean',
          default: false
        },
        "processingProgress": {
          name: 'processingProgress',
          type: 'number',
          default: 0
        },
        "processingError": {
          name: 'processingError',
          type: 'string',
          default: 'null'
        },
        "processingStartTime": {
          name: 'processingStartTime',
          type: 'Date',
          default: new Date(0)
        },
        "processingEndTime": {
          name: 'processingEndTime',
          type: 'Date',
          default: new Date(0)
        },
        "processingElapsedTime": {
          name: 'processingElapsedTime',
          type: 'number',
          default: 0
        },
        "Container": {
          name: 'Container',
          type: 'string'
        },
        "createdByIp": {
          name: 'createdByIp',
          type: 'string'
        },
        "lastUpdatedByIp": {
          name: 'lastUpdatedByIp',
          type: 'string'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
        "libraryId": {
          name: 'libraryId',
          type: 'string'
        },
      },
      relations: {
        library: {
          name: 'library',
          type: 'Library',
          model: 'Library',
          relationType: 'belongsTo',
                  keyFrom: 'libraryId',
          keyTo: 'id'
        },
        screens: {
          name: 'screens',
          type: 'Screen[]',
          model: 'Screen',
          relationType: 'hasMany',
          modelThrough: 'ScreenVideo',
          keyThrough: 'screenId',
          keyFrom: 'id',
          keyTo: 'videoId'
        },
        tags: {
          name: 'tags',
          type: 'Tag[]',
          model: 'Tag',
          relationType: 'hasMany',
          modelThrough: 'TagVideo',
          keyThrough: 'tagId',
          keyFrom: 'id',
          keyTo: 'videoId'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/sdk/models/Video.ts